import React, { useEffect } from 'react';
import { Link, useHistory } from "react-router-dom"
import CmsPageLayout from './layout/CmsPageLayout';
import SeoPageLayout from './layout/SeoPageLayout';

export default function SeoGuyanaSite() {

    return (
        <SeoPageLayout
            title="MooveTrax KS2 – GPS Vehicle Tracker in Guyana"
            description="Protect your vehicle in Guyana with MooveTrax KS2 – advanced GPS tracking, anti-theft killswitch, and real-time monitoring. Available now in Georgetown and worldwide."
            keywords="GPS tracker Guyana, vehicle security Guyana, MooveTrax KS2, vehicle tracker worldwide, anti-theft device Guyana"
        >
            <React.Fragment>
                <section id="about">
                    <h2>About MooveTrax KS2 in Guyana</h2>
                    <p>MooveTrax KS2 is a cutting-edge GPS vehicle tracker designed for drivers in Guyana who want peace of mind and total control over their vehicles. Whether you live in Georgetown, Berbice, or Essequibo, MooveTrax KS2 helps protect your vehicle from theft and ensures you always know where your vehicle is.</p>
                </section>

                <section id="features">
                    <h2>Key Features of MooveTrax KS2</h2>
                    <div class="features">
                        <div class="feature-box">
                            <h3>Real-Time GPS Tracking</h3>
                            <p>See your vehicle’s exact location from your phone or PC, anywhere in the world.</p>
                        </div>
                        <div class="feature-box">
                            <h3>Anti-Theft Killswitch</h3>
                            <p>Remotely disable your vehicle’s starter to prevent theft or recover a stolen vehicle.</p>
                        </div>
                        <div class="feature-box">
                            <h3>Speeding Detection</h3>
                            <p>Get alerts via app and email when your vehicle exceeds speed limits.</p>
                        </div>
                        <div class="feature-box">
                            <h3>Geofencing Alerts</h3>
                            <p>Receive notifications if your vehicle leaves a safe zone.</p>
                        </div>
                        <div class="feature-box">
                            <h3>24/7 Monitoring</h3>
                            <p>Stay connected to your vehicle anytime, day or night.</p>
                        </div>
                        <div class="feature-box">
                            <h3>Worldwide Coverage</h3>
                            <p>Reliable GPS tracking across Guyana and worldwide.</p>
                        </div>
                    </div>
                </section>

                <section id="benefits">
                    <h2>Why Choose MooveTrax KS2 in Guyana?</h2>
                    <ul>
                        <li>Protect your vehicle from theft and unauthorized use.</li>
                        <li>Lower stress with instant vehicle location updates.</li>
                        <li>Improve security for rental vehicles, businesses, and family vehicles.</li>
                        <li>Trusted by drivers in Guyana and Worldwide.</li>
                    </ul>
                </section>

            </React.Fragment>
        </SeoPageLayout>
    )
}
